import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { C } from "./constants";

export const TableroBanner = ({ testId, summary, onDismiss }) => {
  const navigate = useNavigate();
  function open() {
    api.post(`/consulting/tests/${testId}/tablero/event`, { type: "banner_clic" }).catch(() => {});
    navigate(`/consulting/${testId}/tablero`);
  }
  async function dismiss() {
    onDismiss();
    api.post(`/consulting/tests/${testId}/tablero/dismiss-banner`).catch(() => {});
  }
  return (
    <div className="relative rounded-2xl px-5 py-4 mb-6 md:mb-8 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 border" style={{ background: C.mint, borderColor: C.green }} data-testid="tablero-banner">
      {summary.is_new && <span className="self-start sm:self-center rounded px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.18em] text-white" style={{ background: C.gold }} data-testid="tablero-banner-new">Nuevo</span>}
      <div className="flex-1 min-w-0 pr-6 sm:pr-0">
        <div className="text-[15px] font-bold" style={{ color: C.text }}>Convierte tu informe en un plan: abre tu tablero de talento</div>
        <div className="text-[13px] mt-0.5" style={{ color: "#3F5249" }} data-testid="tablero-banner-status">{summary.status_line}</div>
      </div>
      <button onClick={open} className="self-start sm:self-center rounded-full px-5 py-2 text-sm font-semibold text-white" style={{ background: C.green }} data-testid="tablero-banner-open">
        Abrir tablero
      </button>
      <button onClick={dismiss} className="absolute top-3 right-3 sm:static p-1 rounded-full hover:bg-white/70" aria-label="Cerrar banner" data-testid="tablero-banner-dismiss">
        <X className="w-4 h-4" style={{ color: C.text }} />
      </button>
    </div>
  );
};
